import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const ErrorMessage = props => {
    const { message, align = 'left', ...rest } = props;

    if (!message) return null;

    return (
        <Typography display="block" align={align} variant="caption" color="error.main" {...rest}>
            {message}
        </Typography>
    );
};

ErrorMessage.propTypes = {
    message: PropTypes.string,
    ...Typography.propTypes,
};

export default ErrorMessage;
